module.exports = __webpack_public_path__ + "fonts/Agatho-Light.3941bd8c.woff2";